<template>
    <flex-element :element-type="elementType" />
</template>

<script>
import postscribe from 'postscribe';
import baseAtom from '@/mixins/base-atom/base-atom-dumb';

export default {
    name: 'a-html',
    mixins: [baseAtom],

    props: {
        richText: {
            type: String,
            default: '',
        },
    },

    mounted() {
        postscribe(this.$el, this.richText);
    },
};
</script>
